import { useAppStore } from "store/store";

const useMultipaxSession = () => {
  const paxSessions = useAppStore((state) => state.paxSessions);
  return paxSessions.length > 1;
};

export default useMultipaxSession;
